export default __webpack_public_path__ + "static/logo-8886a1884fd3b66d9a70ec97ddf6c96c.svg";